export default __webpack_public_path__ + "static/media/welcome-what-is-my-mroom.ac71ab16.png";